import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'
import { Product } from 'features/types'

type OwnProps = {
  campaignId: number
  productIndex?: number
  product: Product
}

const mapStateToProps = (state: ReduxState) => {
  return {
    error: selectors.errorSelector(state)
  }
}

const mapDispatchToProps = {
  saveSubscriptionData: actions.saveSubscriptionData,

  updateProductSubscriptions: actions.updateProductSubscriptions
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector> & OwnProps
